import { render, staticRenderFns } from "./ListCargaSaraivaView.vue?vue&type=template&id=4edc791f&"
import script from "./ListCargaSaraivaView.vue?vue&type=script&lang=ts&"
export * from "./ListCargaSaraivaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports